import React from "react";
import { FieldFeedback, FormValidationNotice, RequiredMark } from "../../../../components/FormValidation";
import useFormValidation from "../../../../hooks/useFormValidation";
import { validationRules as rule } from "../../../../utils/helpers/formValidation";

const provinceSchema = { id: rule.required("Kode provinsi wajib diisi."), name: rule.required("Nama provinsi wajib diisi.") };

const FormProvince = (props) => {
  const { isEdit, closeModal, formState, setFormState, handleAdd, handleUpdate } = props;
  const validation = useFormValidation({ values: formState, schema: provinceSchema, formId: "province" });
  const submit = async (event) => {
    event.preventDefault();
    if (!validation.validateAll()) return;
    const success = isEdit ? await handleUpdate() : await handleAdd();
    if (success !== false) document.querySelector("#modal-form .btn-close")?.click();
  };

  return (
    <div
      // className={
      //   isShowModal ? "modal modal-blur fade show" : "modal modal-blur fade "
      // }
      className="modal modal-blur fade "
      id="modal-form"
      tabIndex="-1"
      role="dialog"
      aria-hidden="false"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.3)",
      }}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <form className="modal-content" onSubmit={submit} noValidate>
          <div className="modal-header">
            <h5 className="modal-title">Master Provinsi {!isEdit ? "Baru" : "Edit"}</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={closeModal}></button>
          </div>
          <div className="modal-body">
            <FormValidationNotice errors={validation.errors} />
            <div className="row">
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Kode<RequiredMark /></label>
                  <input
                    {...validation.fieldProps("id")}
                    type="text"
                    className={validation.inputClass("id")}
                    placeholder="kode provinsi"
                    value={formState?.id || ""}
                    onChange={(e) =>
                      setFormState((prev) => ({
                        ...prev,
                        id: e.target.value,
                      }))
                    }
                  />
                  <FieldFeedback formId="province" name="id" error={validation.errors.id} hint="Gunakan kode wilayah resmi dan unik." />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Nama<RequiredMark /></label>
                  <input
                    {...validation.fieldProps("name")}
                    type="text"
                    className={validation.inputClass("name")}
                    placeholder="nama provinsi"
                    value={formState?.name || ""}
                    onChange={(e) =>
                      setFormState((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                  />
                  <FieldFeedback formId="province" name="name" error={validation.errors.name} hint="Nama provinsi wajib diisi." />
                </div>
              </div>

              <div className="col-lg-12">
                <div>
                  <label className="form-label">Informasi Tambahan</label>
                  <textarea className="form-control" rows="3"></textarea>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary btn-3" data-bs-dismiss="modal">
              Cancel
            </button>
            {isEdit ? (
              <button type="submit" className="btn btn-primary btn-5 ms-auto">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-edit">
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                  <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                  <path d="M16 5l3 3" />
                </svg>
                Edit Data
              </button>
            ) : (
              <button type="submit" className="btn btn-primary btn-5 ms-auto">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-2">
                  <path d="M12 5l0 14" />
                  <path d="M5 12l14 0" />
                </svg>
                Tambah Data
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormProvince;
